export class FundCategoryModel {
  private readonly _categoryLvl1Name: string = ''
  private readonly _categoryLvl2Name: string = ''
  private readonly _categoryLvl3Name: string = ''
  private _fundDtlAry: any[] = []

  constructor(
    categoryLvl1Name: string,
    categoryLvl2Name: string,
    categoryLvl3Name: string,
  ) {
    this._categoryLvl1Name = categoryLvl1Name || ''
    this._categoryLvl2Name = categoryLvl2Name || ''
    this._categoryLvl3Name = categoryLvl3Name || ''
  }
  compare(fundCategoryModel: FundCategoryModel): boolean {
    return (
      fundCategoryModel._categoryLvl1Name === this._categoryLvl1Name &&
      fundCategoryModel._categoryLvl2Name === this._categoryLvl2Name &&
      fundCategoryModel._categoryLvl3Name === this._categoryLvl3Name
    )
  }

  get categoryLvl1Name(): string {
    return this._categoryLvl1Name
  }

  get categoryLvl2Name(): string {
    return this._categoryLvl2Name
  }

  get categoryLvl3Name(): string {
    return this._categoryLvl3Name
  }

  get fundDtlAry(): any[] {
    return this._fundDtlAry
  }

  set fundDtlAry(value: any[]) {
    this._fundDtlAry = value
  }
}
